export default __webpack_public_path__ + "static/media/illu_qualite.b5fcbba7.png";